var _rect, _rect2, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcFlagsJpyUsd(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 15,
    rx: 1,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4444_49414",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 15
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 15,
    rx: 1,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4444_49414)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 1.17,
    fill: "#B22234"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 13.82,
    width: 20,
    height: 1.17,
    fill: "#B22234"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 2.32001,
    width: 20,
    height: 1.153,
    fill: "#B22234"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 4.62,
    width: 20,
    height: 1.153,
    fill: "#B22234"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 6.91998,
    width: 20,
    height: 1.153,
    fill: "#B22234"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 9.21997,
    width: 20,
    height: 1.153,
    fill: "#B22234"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 11.52,
    width: 20,
    height: 1.153,
    fill: "#B22234"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.999999C0 0.447714 0.447715 0 1 0H10V8.07H0V0.999999Z",
    fill: "#3C3B6E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 3.5L8.11226 3.84549H8.47553L8.18164 4.05902L8.29389 4.40451L8 4.19098L7.70611 4.40451L7.81836 4.05902L7.52447 3.84549H7.88774L8 3.5Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 6.5L8.11226 6.84549H8.47553L8.18164 7.05902L8.29389 7.40451L8 7.19098L7.70611 7.40451L7.81836 7.05902L7.52447 6.84549H7.88774L8 6.5Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9 5L9.11226 5.34549H9.47553L9.18164 5.55902L9.29389 5.90451L9 5.69098L8.70611 5.90451L8.81836 5.55902L8.52447 5.34549H8.88774L9 5Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6 3.5L6.11226 3.84549H6.47553L6.18164 4.05902L6.29389 4.40451L6 4.19098L5.70611 4.40451L5.81836 4.05902L5.52447 3.84549H5.88774L6 3.5Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6 6.5L6.11226 6.84549H6.47553L6.18164 7.05902L6.29389 7.40451L6 7.19098L5.70611 7.40451L5.81836 7.05902L5.52447 6.84549H5.88774L6 6.5Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7 5L7.11226 5.34549H7.47553L7.18164 5.55902L7.29389 5.90451L7 5.69098L6.70611 5.90451L6.81836 5.55902L6.52447 5.34549H6.88774L7 5Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M4 3.5L4.11226 3.84549H4.47553L4.18164 4.05902L4.29389 4.40451L4 4.19098L3.70611 4.40451L3.81836 4.05902L3.52447 3.84549H3.88774L4 3.5Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M4 6.5L4.11226 6.84549H4.47553L4.18164 7.05902L4.29389 7.40451L4 7.19098L3.70611 7.40451L3.81836 7.05902L3.52447 6.84549H3.88774L4 6.5Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M5 5L5.11226 5.34549H5.47553L5.18164 5.55902L5.29389 5.90451L5 5.69098L4.70611 5.90451L4.81836 5.55902L4.52447 5.34549H4.88774L5 5Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M2 3.5L2.11226 3.84549H2.47553L2.18164 4.05902L2.29389 4.40451L2 4.19098L1.70611 4.40451L1.81836 4.05902L1.52447 3.84549H1.88774L2 3.5Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M2 6.5L2.11226 6.84549H2.47553L2.18164 7.05902L2.29389 7.40451L2 7.19098L1.70611 7.40451L1.81836 7.05902L1.52447 6.84549H1.88774L2 6.5Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M3 5L3.11226 5.34549H3.47553L3.18164 5.55902L3.29389 5.90451L3 5.69098L2.70611 5.90451L2.81836 5.55902L2.52447 5.34549H2.88774L3 5Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M1 5L1.11226 5.34549H1.47553L1.18164 5.55902L1.29389 5.90451L1 5.69098L0.706107 5.90451L0.818364 5.55902L0.524472 5.34549H0.887743L1 5Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M8 0.5L8.11226 0.845491H8.47553L8.18164 1.05902L8.29389 1.40451L8 1.19098L7.70611 1.40451L7.81836 1.05902L7.52447 0.845491H7.88774L8 0.5Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M9 2L9.11226 2.34549H9.47553L9.18164 2.55902L9.29389 2.90451L9 2.69098L8.70611 2.90451L8.81836 2.55902L8.52447 2.34549H8.88774L9 2Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M6 0.5L6.11226 0.845491H6.47553L6.18164 1.05902L6.29389 1.40451L6 1.19098L5.70611 1.40451L5.81836 1.05902L5.52447 0.845491H5.88774L6 0.5Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M7 2L7.11226 2.34549H7.47553L7.18164 2.55902L7.29389 2.90451L7 2.69098L6.70611 2.90451L6.81836 2.55902L6.52447 2.34549H6.88774L7 2Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M4 0.5L4.11226 0.845491H4.47553L4.18164 1.05902L4.29389 1.40451L4 1.19098L3.70611 1.40451L3.81836 1.05902L3.52447 0.845491H3.88774L4 0.5Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M5 2L5.11226 2.34549H5.47553L5.18164 2.55902L5.29389 2.90451L5 2.69098L4.70611 2.90451L4.81836 2.55902L4.52447 2.34549H4.88774L5 2Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M2 0.5L2.11226 0.845491H2.47553L2.18164 1.05902L2.29389 1.40451L2 1.19098L1.70611 1.40451L1.81836 1.05902L1.52447 0.845491H1.88774L2 0.5Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M3 2L3.11226 2.34549H3.47553L3.18164 2.55902L3.29389 2.90451L3 2.69098L2.70611 2.90451L2.81836 2.55902L2.52447 2.34549H2.88774L3 2Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M1 2L1.11226 2.34549H1.47553L1.18164 2.55902L1.29389 2.90451L1 2.69098L0.706107 2.90451L0.818364 2.55902L0.524472 2.34549H0.887743L1 2Z",
    fill: "white"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4444_49414)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 23.1667C24 23.6271 23.6271 24 23.1667 24H4.83333C4.37292 24 4 23.6271 4 23.1667V9.83333C4 9.37292 4.37292 9 4.83333 9H23.1667C23.6271 9 24 9.37292 24 9.83333V23.1667Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 12.3333C16.3013 12.3333 18.1667 14.1987 18.1667 16.5C18.1667 18.8012 16.3013 20.6667 14 20.6667C11.6988 20.6667 9.83337 18.8012 9.83337 16.5C9.83337 14.1987 11.6988 12.3333 14 12.3333Z",
    fill: "#BA0831"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4444_49414",
    x: 0,
    y: 5,
    width: 28,
    height: 23,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.164706 0 0 0 0 0.168627 0 0 0 0 0.188235 0 0 0 0.35 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4444_49414"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4444_49414",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFlagsJpyUsd);
export default __webpack_public_path__ + "static/media/ic_flags_jpy_usd.b571c469.svg";
export { ForwardRef as ReactComponent };